import { Component, inject, Input } from '@angular/core';
import { branch } from '@tytapp/common';
import { ContentBlocksService } from '@tytapp/content/content-blocks.service';

@Component({
    templateUrl: './condition-simulator.component.html',
    styleUrl: './condition-simulator.component.scss',
    standalone: false
})
export class ConditionSimulatorComponent {
    private contentBlocks = inject(ContentBlocksService);
    variables = this.contentBlocks.getConditionVariables();

    private values: Record<string, any> = {};

    @Input() changed: () => void;

    isOverridden(name: string) {
        return this.contentBlocks.isConditionVariableOverridden(name);
    }

    getValue(name: string) {
        if (!(name in this.values)) {
            branch(async () => this.values[name] = await this.contentBlocks.getConditionVariableValue(name));
        }

        return this.values[name];
    }

    getOverriddenVariables() {
        return this.contentBlocks.getOverriddenVariables();
    }

    overrideValue(name: string, value: any) {
        this.values[name] = value;
        this.contentBlocks.overrideConditionVariable(name, value);
        this.changed?.();
    }

    resetOverride(name: string) {
        this.contentBlocks.removeConditionVariableOverride(name);
        this.changed?.();
        branch(async () => this.values[name] = await this.contentBlocks.getConditionVariableValue(name));
    }
}